import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-221d5e78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "publish_detail" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "body col-lg-8 card card-body border-0" }
const _hoisted_4 = { class: "text-primary fw-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "px-0 user_details" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Program Area", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "SubProgram Area", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Description of Health Need/Challenge", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Description of Required Solution", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Target End User:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Benefits to End User", -1))
const _hoisted_15 = {
  key: 0,
  class: "attached_file"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Attached files", -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "side col-lg-4" }
const _hoisted_21 = { class: "text-primary fs-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Evaluation Comment", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = { class: "mb-0" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Supervisor Comment", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "healthChallenge" }, [
  /*#__PURE__*/_createTextVNode("Comments/Suggestions"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-2" }, "*")
], -1))
const _hoisted_35 = { class: "w-100 text-muted d-flex justify-content-end mr-3" }
const _hoisted_36 = { class: "btn_container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.getHealthNeed?.title), 1),
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", null, " Submitted by " + _toDisplayString(_ctx.getHealthNeed?.author_first_name) + " " + _toDisplayString(_ctx.getHealthNeed?.author_middle_name) + " " + _toDisplayString(_ctx.getHealthNeed?.author_last_name), 1),
          _createElementVNode("li", null, "Employee Number- " + _toDisplayString(_ctx.getHealthNeed?.author_employee_number), 1),
          _createElementVNode("li", null, "Email Address: " + _toDisplayString(_ctx.getHealthNeed?.author_email), 1),
          _createElementVNode("li", null, "Approved by: " + _toDisplayString(_ctx.getHealthNeed?.supervisor_name), 1)
        ]),
        (_ctx.getHealthNeed?.program_areas?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("p", null, _toDisplayString(_ctx.getHealthNeed?.program_areas[0]?.name), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHealthNeed?.specific_program_areas?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHealthNeed?.specific_program_areas, (item, i) => {
                  return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(item.name) + ", ", 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_11,
        _createElementVNode("p", null, _toDisplayString(_ctx.getHealthNeed?.description), 1),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createElementVNode("p", null, _toDisplayString(_ctx.getHealthNeed?.requirements), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("p", null, _toDisplayString(_ctx.getHealthNeed?.target_users), 1),
          _hoisted_14,
          _createElementVNode("p", null, _toDisplayString(_ctx.getHealthNeed?.benefits), 1),
          (_ctx.getHealthNeed?.document_upload?.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHealthNeed?.document_upload, (item, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, [
                    _hoisted_16,
                    _createElementVNode("a", {
                      target: "_blank",
                      rel: "noopener noreferrer",
                      href: `${_ctx.url}${item}`
                    }, [
                      _createElementVNode("img", {
                        src: require(`@/assets/placeholder/${_ctx.getFileExt(item)}.svg`),
                        alt: "placeholder_img ",
                        width: "40"
                      }, null, 8, _hoisted_18),
                      _createElementVNode("span", _hoisted_19, " " + _toDisplayString(_ctx.getFileName(item)), 1)
                    ], 8, _hoisted_17)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", null, [
          _createElementVNode("h5", null, [
            _createTextVNode(" Evaluation Score: "),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.percentage(_ctx.getHealthNeed?.evaluation?.average_score)) + "%", 1)
          ]),
          _hoisted_22,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHealthNeed?.evaluation?.evaluators, (item, i) => {
            return (_openBlock(), _createElementBlock("p", { key: i }, [
              _createTextVNode(_toDisplayString(item?.first_name) + " " + _toDisplayString(item?.last_name) + ": ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.percentage(item.score)) + "%", 1)
            ]))
          }), 128)),
          _hoisted_23
        ]),
        _createElementVNode("div", null, [
          _hoisted_24,
          _hoisted_25,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHealthNeed?.evaluation?.evaluators, (item, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              _createElementVNode("h6", _hoisted_26, " Name: " + _toDisplayString(item?.first_name) + " " + _toDisplayString(item?.last_name), 1),
              _createElementVNode("small", null, "Email: " + _toDisplayString(item?.email), 1),
              _hoisted_27,
              _createElementVNode("small", null, "Comment: " + _toDisplayString(item.comment), 1),
              _hoisted_28
            ]))
          }), 128))
        ]),
        _createElementVNode("div", null, [
          _hoisted_29,
          _hoisted_30,
          _createElementVNode("h6", null, "Name: " + _toDisplayString(_ctx.getHealthNeed?.supervisor_name), 1),
          _createElementVNode("small", null, "Email: " + _toDisplayString(_ctx.getHealthNeed?.supervisor_email), 1),
          _hoisted_31,
          _createElementVNode("small", null, "Comment: " + _toDisplayString(_ctx.getHealthNeed?.supervisor_comment), 1),
          _hoisted_32
        ]),
        _createElementVNode("form", {
          name: "PublishForm",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(_component_Textarea, {
              modelValue: _ctx.comment,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
              id: "comment",
              name: "comment",
              autoResize: true,
              rows: "5",
              cols: "30",
              placeholder: "Enter text here...",
              class: "w-100",
              maxlength: "200"
            }, null, 8, ["modelValue"]),
            _createElementVNode("small", _hoisted_35, _toDisplayString(_ctx.comment.length) + "/200", 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_BaseButton, {
              onClick: _ctx.onReject,
              disabled: _ctx.loading1,
              class: _normalizeClass({ submitting: _ctx.loading1 }),
              customStyle: _ctx.btnStyle2
            }, {
              default: _withCtx(() => [
                _createTextVNode("Reject Health Need")
              ]),
              _: 1
            }, 8, ["onClick", "disabled", "class", "customStyle"]),
            _createVNode(_component_BaseButton, {
              type: "submit",
              disabled: _ctx.loading,
              class: _normalizeClass({ submitting: _ctx.loading }),
              customStyle: _ctx.btnStyle3
            }, {
              default: _withCtx(() => [
                _createTextVNode("Publish Health Need")
              ]),
              _: 1
            }, 8, ["disabled", "class", "customStyle"])
          ])
        ], 32)
      ])
    ])
  ]))
}